/**
 * "Резюме звонка" card — free-text summary + structured SAO (Situation / Actions / Outcome)
 */

import { useTranslation } from 'react-i18next';
import { AnalysisSection, type XMLAnalysisResult } from './analysis-utils';

interface SummarySectionProps {
  result: XMLAnalysisResult;
}

export function SummarySection({ result }: SummarySectionProps) {
  const { t } = useTranslation('records');

  if (!result.textSummary && !result.structuredSummary) return null;

  const sao = result.structuredSummary;

  return (
    <AnalysisSection
      title={t('records.analysisPanel.summary.title', 'Summary')}
      defaultOpen
    >
      {result.textSummary && (
        <p className="text-[13px] leading-relaxed text-fg">{result.textSummary}</p>
      )}

      {sao && (
        <div className="mt-3.5 flex flex-col gap-2.5">
          {sao.situation && (
            <div>
              <div className="mb-1 font-mono text-micro font-semibold uppercase tracking-wide text-primary">
                {t('records.analysisPanel.situation', 'Situation')}
              </div>
              <p className="text-xs leading-relaxed text-fg-secondary">{sao.situation}</p>
            </div>
          )}
          {sao.actions && sao.actions.length > 0 && (
            <div>
              <div className="mb-1 font-mono text-micro font-semibold uppercase tracking-wide text-primary">
                {t('records.analysisPanel.actions', 'Actions')}
              </div>
              <div className="flex flex-col gap-1">
                {sao.actions.map((a, i) => (
                  <div key={i} className="flex gap-1.5 text-xs leading-relaxed">
                    <span className="shrink-0 text-primary">→</span>
                    <span className="flex-1 text-fg-secondary">{a}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {sao.outcome && (
            <div>
              <div className="mb-1 font-mono text-micro font-semibold uppercase tracking-wide text-primary">
                {t('records.analysisPanel.outcome', 'Outcome')}
              </div>
              <p className="text-xs leading-relaxed text-fg-secondary">{sao.outcome}</p>
            </div>
          )}
        </div>
      )}
    </AnalysisSection>
  );
}
